import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-disqus',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Disqus icon</title><path d="M12.438 23.654c-2.853 0-5.46-1.04-7.476-2.766L0 21.568l1.917-4.733C1.25 15.36.875 13.725.875 12 .875 5.564 6.05.346 12.44.346 18.82.346 24 5.564 24 12c0 6.438-5.176 11.654-11.562 11.654zm6.315-11.687v-.033c0-3.363-2.373-5.76-6.462-5.76H7.877V17.83h4.35c4.12 0 6.525-2.5 6.525-5.863h.004zm-6.415 2.998h-1.29V9.04h1.29c1.897 0 3.157 1.08 3.157 2.945v.03c0 1.884-1.26 2.95-3.157 2.95z"/></svg>`,
    styles: []
})
export class SimpleIconsDisqusComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#2E9FFF';
    @Input() className: string = 'simple-icons-disqus'
    constructor() {}
    ngOnInit(): void {}
}
